import React from "react";
import { Upload, message } from "antd";
import { Storage } from "aws-amplify";
import UploadIcon from "../../../../../assets/images/upload-icon.svg";
import { fileUploadProps } from "./constants";
import { mimeTypeLabels } from "../../../../../constants/MiscKeys";

const { Dragger } = Upload;

const PdfUploader = ({
  onUploadSuccess,
  onFileRemove,
  maxCount,
  allowedFileTypes,
  fileList,
  setFileList,
}) => {

  const { SIZE_WARNING, PROGRESS_COLOR, HINT_1, HINT_2 } =
    fileUploadProps;

  const getTypeHintText = () => {
    if (allowedFileTypes?.length) {
      const readableTypes = allowedFileTypes
        .map((t) => mimeTypeLabels[t] || "")
        .join(", ");
      return `, Only ${readableTypes} files are allowed`;
    }
  };

  const props = {
    name: "file",
    fileList: fileList,
    maxCount: 1,

    beforeUpload: (file) => {
      if (fileList.length >= maxCount) {
        message.error(`You can only upload up to ${maxCount} files.`);
        return Upload.LIST_IGNORE;
      }
      if (allowedFileTypes && allowedFileTypes.length > 0) {
        if (!allowedFileTypes.includes(file.type)) {
          const readableTypes = allowedFileTypes
            .map((t) => mimeTypeLabels[t] || t)
            .join(", ");
          message.error(
            `Invalid file type. Only ${readableTypes} files are allowed.`
          );
          return Upload.LIST_IGNORE;
        }
      }
      const isLt10MB = file.size / 1024 / 1024 < 10;
      if (!isLt10MB) {
        message.error(SIZE_WARNING);
        return Upload.LIST_IGNORE;
      }
      return true;
    },

    customRequest: async ({ file, onSuccess, onError, onProgress }) => {
      const uniqueFileName = `${Date.now()}-${file.name}`;

      try {

        const result = await Storage.put(uniqueFileName, file, {
          contentType: file.type,
          progressCallback: (progress) => {
            const percent = Math.round(
              (progress.loaded / progress.total) * 100,
            );
            onProgress({ percent }, file);
          },
        });

        const fileURL = await Storage.get(result.key, { level: "public" });
        const cleanS3Link = fileURL.split("?")[0];

        if (onUploadSuccess) {
          onUploadSuccess(cleanS3Link);
        }

        setFileList([
          { uid: file.uid, name: file.name, status: "done", url: cleanS3Link },
        ]);
        message.success({
          content: `${file.name} uploaded successfully.`,
          key: "upload-status",
        });
        onSuccess();
      } catch (error) {
        console.error("S3 Upload Error:", error);
        message.error({
          content: `${file.name} upload failed.`,
          key: "upload-status",
        });
        onError(error);
      }
    },
    onChange: (info) => {
      setFileList(info?.fileList ?? []);
    },
    onRemove: () => {
      setFileList([]);
      if (onFileRemove) {
        onFileRemove();
      }
    },

    progress: {
      style: { marginLeft: 16 },
      strokeColor: PROGRESS_COLOR,
    },
  };

  return (
    <Dragger {...props}>
      <p>
        <img src={UploadIcon} alt="upload icon" />
      </p>
      <p className="ant-upload-text">{HINT_1}</p>
      <p className="ant-upload-hint">{HINT_2}{getTypeHintText()}</p>
    </Dragger>
  );
};

export default PdfUploader;
